import React from 'react';
const MOCKUP = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/9371e20f-4840-4491-87e5-388382fbf526/1793758936160_agenda-activa-bundle-de-bienestar-senior-48339359.webp';
// Bordes del mockup que se funden con el fondo (sin recuadro)
const fade = 'radial-gradient(ellipse 62% 60% at 50% 50%, #000 62%, rgba(0,0,0,0) 100%)';
export function HeroSection() {
  const pill = 'bg-black/30 border border-[#F2C14E]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap';
  return <section className="relative w-full flex flex-col items-center text-center px-5 pt-5 pb-10 sm:pt-12 sm:pb-16 overflow-hidden" style={{
    background: 'linear-gradient(135deg, #04201a 0%, #0b3a2d 45%, #06291f 100%)'
  }} data-id="element-106" data-mp="30n55oa3pgqb3">
      <div className="mb-2" data-id="element-107" data-mp="3fius29csz5gc">
        <span className="text-[#F2C14E] text-xl sm:text-2xl font-black tracking-widest" data-id="element-108" data-mp="3fht79d5zj4lf">
          🪑 AGENDA ACTIVA
        </span>
      </div>
      <p className="text-[#9FE0C8] text-[10px] sm:text-sm font-bold tracking-[0.2em] mb-4" data-id="element-109" data-mp="3kb4idqhty7j5">
        KINESIOLOGÍA · TERAPIA OCUPACIONAL · CENTROS DE DÍA
      </p>

      <h1 className="font-black text-white max-w-5xl text-[28px] sm:text-5xl md:text-6xl leading-[1.1]" data-id="element-110" data-mp="2bf83maadw580">
        Tus próximas 36 sesiones con adultos mayores.
        <br data-id="element-111" data-mp="2kev66zeunh2n" />
        <span className="text-[#F2C14E]" data-id="element-112" data-mp="2ked2xitrs2l8">Ya armadas. Listas para imprimir.</span>
      </h1>

      <div className="relative w-[calc(100%+40px)] sm:w-full max-w-[820px] mt-3 mb-2" data-id="element-113" data-mp="2z2zs0c9788pn">
        <img src={MOCKUP} alt="Agenda Activa: Tomo 1, Tomo 2 y los 4 bonos" width={1536} height={1024} fetchPriority="high" className="w-full h-auto block" style={{
        WebkitMaskImage: fade,
        maskImage: fade
      }} data-id="element-114" data-mp="2u4oik2mtg07y" />
        <div className="absolute right-[4%] bottom-[2%] w-[24%] max-w-[170px] aspect-square rounded-full flex flex-col items-center justify-center text-center -rotate-[8deg]" style={{
        background: 'radial-gradient(circle at 35% 30%,#fff3b0,#f2c14e 35%,#c8901a 70%,#8a5c0a)',
        boxShadow: '0 10px 24px rgba(0,0,0,.45), inset 0 0 0 4px rgba(255,255,255,.35), inset 0 0 0 7px #b8800f',
        color: '#3a2600',
        containerType: 'inline-size'
      } as React.CSSProperties} data-id="element-115" data-mp="334l4hwhtmkzb">
          <b className="font-black leading-none" style={{
          fontSize: '32cqw'
        }} data-id="element-116" data-mp="3iqzdn5rw6mhr">36</b>
          <span className="font-black leading-[1.1]" style={{
          fontSize: '10.5cqw'
        }} data-id="element-117" data-mp="3msui2j54dfzr">SESIONES<br data-id="element-118" data-mp="3mqrj39lzociw" />LISTAS</span>
          <small className="font-bold mt-[3%]" style={{
          fontSize: '8cqw'
        }} data-id="element-119" data-mp="3rsp3w8a1ffdy">2 tomos + 4 bonos</small>
        </div>
      </div>

      <p className="text-[#9FE0C8] font-bold text-[16px] sm:text-2xl max-w-3xl" data-id="element-120" data-mp="kl2tfox6snl">
        12 semanas de talleres grupales de 45 minutos — físico, cognitivo y lúdico
      </p>
      <p className="text-white text-[16px] sm:text-lg max-w-2xl py-2" data-id="element-121" data-mp="abyxna5xf4ae">
        Abres la sesión del día, la imprimes y la das. Sin buscar ejercicios. Sin armar la secuencia. Sin improvisar.
      </p>

      <div className="flex flex-wrap gap-[4px] sm:gap-[6px] items-center justify-center mt-2 mb-2" data-id="element-122" data-mp="jbm101i7uk63">
        <span className={pill} data-id="element-123" data-mp="23uofd3tec5xj">📄 PDF A4</span>
        <span className={pill} data-id="element-124" data-mp="23sbnnyxu6h7a">⚡ Acceso inmediato</span>
        <span className={pill} data-id="element-125" data-mp="1yv1zemm6obl1">♿ Versión silla de ruedas</span>
        <span className={pill} data-id="element-126" data-mp="1utqa6i781sdd">🧠 Cuerpo + cabeza</span>
      </div>

      <a href="#pricing" className="btn-pulse bg-[#F2C14E] text-[#2a1d00] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#F7D27A] transition-colors inline-block mt-5 mb-5 w-full sm:w-auto max-w-sm" data-id="element-127" data-mp="1uu01c94065kn">
        QUIERO MIS 36 SESIONES →
      </a>

      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-128" data-mp="2ikdmrgs31669">
        <span data-id="element-129" data-mp="2dr19g2suslst">🛡️ Garantía 7 días</span>
        <span data-id="element-130" data-mp="28tiv1ww2hedf">🔒 Pago seguro</span>
        <span data-id="element-131" data-mp="28sg6vwq4pq17">📩 Llega al instante a tu correo</span>
      </p>
    </section>;
}